import React from "react";
import { compose, withHandlers } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import Byline from "./Byline";
import { updateMap } from "app/map/actions";
import { computeBounds } from "app/map/utils";

const StyledProposal = styled.div.attrs({
  className: "pt-card pt-elevation-1 pt-interactive"
})`
  margin-bottom: 1ex;
  text-decoration: none;
  color: black;
  overflow: hidden;
  & h5 {
    font-size; 1em;
  }
`;

const withProposal = compose(
  withRouter,
  connect(
    null,
    dispatch => ({
      updateMap: options => dispatch(updateMap(options))
    })
  ),
  withHandlers({
    onClick: props => () => {
      const {
        history,
        updateMap,
        proposal: {
          location,
          ui: { path }
        }
      } = props;
      if (location) {
        const bounds = computeBounds(location);
        updateMap({ bounds });
      }
      const urlSearch = window.location.search;
      history.push(path + urlSearch);
    }
  })
);

const ProposalItem = withProposal(props => {
  const { proposal, onClick } = props;
  const {
    title,
    _id,
    ui: { brief }
  } = proposal;
  return (
    <StyledProposal onClick={onClick}>
      <h5>{title || _id}</h5> <p>{brief}</p>
      <Byline proposal={proposal} />
    </StyledProposal>
  );
});

const ProposalList = props => {
  const { proposals } = props;
  return proposals.map(proposal => (
    <ProposalItem proposal={proposal} key={proposal._id} />
  ));
};

export default ProposalList;



// WEBPACK FOOTER //
// ./src/app/proposals/ProposalList.js